module.exports = __webpack_public_path__ + "static/media/wandsworthMills.e58c57d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wandsworthMills.jpg
// module id = 310
// module chunks = 0